/* Fann Bliss: homepage sections runtime (fann-* sections)
   Reveal, rails, Countries finder, pricing engine + bundle builder, launches + waitlist,
   personalize preview, forms, cart add. No dependencies. */
(function () {
  'use strict';
  if (window.FannHome && window.FannHome.ready) return;
  var FH = window.FannHome = window.FannHome || {};
  FH.ready = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = FH.config || {};
  var routes = cfg.routes || { cart: '/cart', cartAdd: '/cart/add.js', cartGet: '/cart.js' };
  var designMode = !!(window.Shopify && Shopify.designMode);

  /* ---------------------------------------------------------------- money */
  function money(cents) {
    var fmt = (cfg.moneyFormat || 'AED {{amount}}').replace(/<[^>]*>/g, '');
    var amount = cents / 100;
    var str;
    if (/amount_no_decimals/.test(fmt)) str = Math.round(amount).toLocaleString('en');
    else str = amount % 1 === 0 ? amount.toLocaleString('en') : amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, str);
  }
  FH.money = money;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast(text, img, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fh fh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = (img ? '<img src="' + esc(img) + '" alt="">' : '') +
      '<svg class="fh-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' + (opts.error ? '<path d="M12 8v5M12 16h.01"/><circle cx="12" cy="12" r="9"/>' : '<path d="m5 12 4.5 4.5L19 7"/>') + '</svg>' +
      '<span>' + esc(text) + '</span>' + (opts.link ? '<a href="' + esc(opts.link) + '">' + esc(opts.linkText || 'View bag') + '</a>' : '');
    toastEl.classList.toggle('fh-error', !!opts.error);
    toastEl.classList.add('fh-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('fh-on'); }, opts.duration || 3200);
  }
  FH.toast = toast;

  /* ----------------------------------------------------------------- cart */
  function updateCartCount(count) {
    var sels = ['[data-cart-count]', '.cart-count-bubble span:not(.visually-hidden)', '.cart-count', '.cartCount', '.header__cart-count', '.cart-count-number', '[data-cart-count-bubble]', '.cart-icon-bubble .count', '.cart-count-bubble'];
    sels.forEach(function (s) { $$(s).forEach(function (el) { if (el.children.length === 0) el.textContent = count; el.removeAttribute('hidden'); }); });
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('fann:cart:updated', { detail: { item_count: count } }));
  }
  function addItems(items, note) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Could not add to bag');
        return data;
      });
    }).then(function (data) {
      return fetch(routes.cartGet, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        updateCartCount(cart.item_count);
        return { added: data, cart: cart };
      });
    });
  }
  FH.addItems = addItems;
  function thumb(url) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : ''; }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fh-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var ids = String(btn.getAttribute('data-fh-add')).split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
    if (!ids.length) return;
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    btn.setAttribute('aria-busy', 'true');
    addItems(items).then(function (r) {
      var first = r.added && (r.added.items ? r.added.items[0] : r.added);
      var label = btn.getAttribute('data-fh-label') || (first && first.product_title) || 'Added';
      toast((ids.length > 1 ? ids.length + ' pieces added' : label + ' added'), first && first.image ? thumb(first.image) : null, { link: routes.cart, linkText: 'View bag' });
      btn.removeAttribute('aria-busy');
    }).catch(function (err) {
      toast(err.message || 'Could not add to bag', null, { error: true });
      btn.removeAttribute('aria-busy');
    });
  });

  /* --------------------------------------------------------------- reveal */
  function initReveal(scope) {
    var els = $$('.fh-rv, .fh-btile, .fh-brush-word', scope);
    if (!('IntersectionObserver' in window) || reduce || designMode) { els.forEach(function (e) { e.classList.add('fh-is-seen'); $$('path', e).forEach(function (p) { p.style.animationPlayState = 'running'; }); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('fh-is-seen'); $$('path', en.target).forEach(function (p) { p.style.animationPlayState = 'running'; }); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) {
      if (e.classList.contains('fh-brush-word') && !e.closest('.fh-hero')) $$('path', e).forEach(function (p) { p.style.animationPlayState = 'paused'; });
      io.observe(e);
    });
  }

  /* ----------------------------------------------------------------- hero */
  function initHero(scope) {
    $$('.fh-hero', scope).forEach(function (hero) {
      requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('fh-is-loaded'); }); });
      var bar = $('[data-fh-mbar]', hero);
      if (!bar) return;
      var toolbar = document.querySelector('.halo-toolbar-mobile, .toolbar-mobile, .halo-toolbar');
      function setOffset() {
        var h = 0;
        if (toolbar && getComputedStyle(toolbar).display !== 'none' && toolbar.offsetHeight) { var r = toolbar.getBoundingClientRect(); if (r.bottom > window.innerHeight - 4) h = r.height; }
        bar.style.setProperty('--fh-toolbar-offset', h + 'px');
      }
      setOffset(); window.addEventListener('resize', setOffset);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { bar.classList.toggle('fh-on', !en.isIntersecting && en.boundingClientRect.top < 0); }); }, { threshold: 0 });
      io.observe(hero);
      var stop = document.querySelector('[data-fh-mbar-stop], .fh-ftr, footer');
      if (stop) { var io2 = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) bar.classList.remove('fh-on'); }); }, { threshold: 0.05 }); io2.observe(stop); }
    });
  }

  /* ------------------------------------------------------------ tabs/rails */
  function initTabs(scope) {
    $$('[data-fh-tabs]', scope).forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap);
      var root = wrap.closest('[data-fh-tabroot]') || wrap.parentElement;
      var panels = $$('[role="tabpanel"]', root);
      function select(tab) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
        panels.forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        if (FH.refreshScrollers) setTimeout(function () { FH.refreshScrollers(root); }, 0);
        var title = $('[data-fh-tab-title]', root), lead = $('[data-fh-tab-lead]', root);
        if (title && tab.getAttribute('data-title')) title.innerHTML = tab.getAttribute('data-title');
        if (lead && tab.getAttribute('data-lead') !== null) lead.textContent = tab.getAttribute('data-lead');
        var panel = panels.filter(function (p) { return !p.hidden; })[0];
        if (panel && !reduce) $$('.fh-pcard', panel).forEach(function (c, i) { c.animate([{ opacity: .3, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: i * 35, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' }); });
        var bar = tab.parentElement;
        if (bar && bar.scrollWidth > bar.clientWidth + 2) { var br = bar.getBoundingClientRect(), tr = tab.getBoundingClientRect(); try { bar.scrollTo({ left: bar.scrollLeft + (tr.left - br.left) - (br.width - tr.width) / 2, behavior: reduce ? 'auto' : 'smooth' }); } catch (_) { bar.scrollLeft += (tr.left - br.left) - (br.width - tr.width) / 2; } }
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (ev) {
          var i = tabs.indexOf(t);
          if (ev.key === 'ArrowRight') { select(tabs[(i + 1) % tabs.length]); tabs[(i + 1) % tabs.length].focus(); }
          if (ev.key === 'ArrowLeft') { select(tabs[(i - 1 + tabs.length) % tabs.length]); tabs[(i - 1 + tabs.length) % tabs.length].focus(); }
        });
      });
    });
    $$('[data-fh-railwrap]', scope).forEach(function (w) {
      var prev = $('[data-rail-prev]', w), next = $('[data-rail-next]', w);
      function rail() { return $$('.fh-rail', w).filter(function (r) { return !r.closest('[hidden]'); })[0]; }
      if (prev) prev.addEventListener('click', function () { var r = rail(); if (r) r.scrollBy({ left: -r.clientWidth * .8, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { var r = rail(); if (r) r.scrollBy({ left: r.clientWidth * .8, behavior: 'smooth' }); });
    });
    $$('.fh-wish', scope).forEach(function (w) { w.addEventListener('click', function (e) { e.preventDefault(); w.classList.toggle('fh-on'); toast(w.classList.contains('fh-on') ? 'Saved to your wishlist' : 'Removed from wishlist'); }); });
  }

  /* ------------------------------------------------------------- scrollers */
  /* Card rails (a row of cards that slides sideways) get a bar under them: back, dots (or a progress bar past 12
     cards), "2 / 5" and forward. Bundle cards, the Shop page rails and the About range join the homepage rails
     here ("You might also like" on product pages has its own, assets/fann-pdp-v2.js); a rail that fills in later or
     appears with its tab is picked up by the observers below. Chip rows use the arrows of chipScroller() instead. */
  var SCROLLERS = '.fh-rail, .fh-timeline, .fh-bgrid, .fh-sets, .fh-launch, [data-fh-scroller], .fb-cards, .flp-rail, .fh-range';
  function initScrollers(scope) {
    var hosts = [];
    $$('[data-fh-railwrap]', scope).forEach(function (w) { hosts.push({ host: w, wrap: true, rails: function () { return $$('.fh-rail', w).filter(function (r) { return !r.closest('[hidden]'); }); } }); });
    $$(SCROLLERS, scope).forEach(function (el) {
      if (el.closest('[data-fh-railwrap]') || el.hasAttribute('data-fh-mugtrack')) return;
      if (el.hasAttribute('data-fh-scroller') && $('[data-fh-track]', el)) return;
      hosts.push({ host: el, wrap: false, rails: function () { return [el]; } });
    });
    hosts.forEach(function (g) {
      if (g.host.__fhCtl) return;
      var ctl = document.createElement('div');
      ctl.className = 'fh-sctl' + (g.host.closest('.fh') ? '' : ' fh-vars'); ctl.hidden = true;
      var chev = function (d) { return '<svg class="fh-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + (d < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>'; };
      ctl.innerHTML = '<button type="button" class="fh-sbtn" data-s-prev aria-label="Previous">' + chev(-1) + '</button><div class="fh-sdots" role="group" aria-label="Slides"></div><span class="fh-scount"></span><button type="button" class="fh-sbtn" data-s-next aria-label="Next">' + chev(1) + '</button>';
      if (g.wrap) g.host.appendChild(ctl); else g.host.insertAdjacentElement('afterend', ctl);
      var dots = $('.fh-sdots', ctl), count = $('.fh-scount', ctl), prev = $('[data-s-prev]', ctl), next = $('[data-s-next]', ctl), bound = null, pending = null, pendingT;
      function items(rail) { return [].filter.call(rail.children, function (c) { return c.offsetWidth > 0 && !c.classList.contains('fh-floor') && !c.classList.contains('fh-empty-note'); }); }
      function nearest(rail, it) { var base = it[0].offsetLeft, sl = rail.scrollLeft, idx = 0, bd = Infinity; it.forEach(function (c, i) { var d = Math.abs((c.offsetLeft - base) - sl); if (d < bd) { bd = d; idx = i; } }); return idx; }
      function perView(rail, it) { if (it.length < 2) return 1; var st = it[1].offsetLeft - it[0].offsetLeft; return Math.max(1, Math.floor((rail.clientWidth + 8) / Math.max(st, 1))); }
      function update() {
        var rail = g.rails()[0];
        if (!rail) { ctl.hidden = true; return; }
        bound = rail;
        var it = items(rail);
        var scrollable = it.length > 1 && rail.scrollWidth > rail.clientWidth + 8;
        ctl.hidden = !scrollable;
        if (!scrollable) return;
        var idx = nearest(rail, it), sl = rail.scrollLeft, maxSl = rail.scrollWidth - rail.clientWidth;
        var useDots = it.length <= 12;
        dots.classList.toggle('fh-sbar', !useDots);
        if (useDots) {
          if (dots.childElementCount !== it.length || !dots.firstElementChild.classList.contains('fh-sdot')) dots.innerHTML = it.map(function (_, i) { return '<button type="button" class="fh-sdot" aria-label="Go to item ' + (i + 1) + '"><i></i></button>'; }).join('');
          [].forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        } else {
          if (!dots.firstElementChild || !dots.firstElementChild.classList.contains('fh-sthumb')) dots.innerHTML = '<i class="fh-sthumb"></i>';
          var th = dots.firstElementChild; th.style.width = Math.max(12, (rail.clientWidth / rail.scrollWidth) * 100) + '%'; th.style.left = Math.min(88, (sl / rail.scrollWidth) * 100) + '%';
        }
        count.textContent = (idx + 1) + ' / ' + it.length;
        prev.setAttribute('aria-disabled', sl <= 2 ? 'true' : 'false');
        next.setAttribute('aria-disabled', sl >= maxSl - 2 ? 'true' : 'false');
      }
      function go(rail, i) { var it = items(rail); i = Math.max(0, Math.min(it.length - 1, i)); pending = i; clearTimeout(pendingT); pendingT = setTimeout(function () { pending = null; }, 700); rail.scrollTo({ left: it[i].offsetLeft - it[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
      function step(dir) { var rail = bound || g.rails()[0]; if (!rail) return; var it = items(rail); var from = pending !== null ? pending : nearest(rail, it); go(rail, from + dir * perView(rail, it)); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      dots.addEventListener('click', function (e) { var d = e.target.closest('.fh-sdot'); if (!d || !bound) return; go(bound, [].indexOf.call(dots.children, d)); });
      var ticking = false;
      function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }
      (g.wrap ? $$('.fh-rail', g.host) : [g.host]).forEach(function (r) { r.addEventListener('scroll', onScroll, { passive: true }); });
      window.addEventListener('resize', onScroll);
      if (window.ResizeObserver) { var ro = new ResizeObserver(onScroll); (g.wrap ? $$('.fh-rail', g.host) : [g.host]).forEach(function (r) { ro.observe(r); }); }
      if (window.MutationObserver && !g.wrap) new MutationObserver(onScroll).observe(g.host, { childList: true });
      g.host.__fhCtl = update;
      update(); setTimeout(update, 700); window.addEventListener('load', update);
    });
  }
  FH.refreshScrollers = function (scope) { $$('[data-fh-railwrap], ' + SCROLLERS, scope || document).forEach(function (h) { if (h.__fhCtl) h.__fhCtl(); }); };
  FH.initScrollers = function (scope) { initScrollers(scope || document); initChipRows(scope || document); };

  /* ------------------------------------------------------------- chip rows
     A row of chips or small cards that slides sideways is marked up as .fh-scroller[data-fh-scroller] holding a
     [data-fh-track] and the two arrows of snippets/fann-catalog-ic (arrows: true). The sides it can still move to fade
     out and show a round arrow, and the first time a row of a kind comes into view in a visit it slides a little and
     back, so a phone shows there is more. The arrows follow the track wherever it sits: a full-bleed track (negative
     side margins) puts them at the screen edge, and they stay centred on the track. Arrows are for pointers and
     thumbs; keyboard users move through the chips themselves. The catalogue (assets/fann-catalog.js) runs the same
     code and skips a row already wired here. */
  function chipScroller(el) {
    if (el.__fhSc) return;
    var tr = $('[data-fh-track]', el); if (!tr) return;
    el.__fhSc = true;
    var kind = el.getAttribute('data-fh-scroller') || 'row', raf = 0, stop = false, geo = true;
    function place() {
      var cs = getComputedStyle(tr);
      el.style.setProperty('--bl', cs.marginLeft); el.style.setProperty('--br', cs.marginRight);
      el.style.setProperty('--ty', Math.round(tr.offsetTop + tr.offsetHeight / 2) + 'px');
    }
    function sync() {
      raf = 0;
      if (geo) { geo = false; place(); }
      var max = tr.scrollWidth - tr.clientWidth, over = max > 4 && tr.offsetParent !== null;
      el.classList.toggle('is-over', over);
      el.classList.toggle('can-l', over && tr.scrollLeft > 4);
      el.classList.toggle('can-r', over && tr.scrollLeft < max - 4);
    }
    function q() { if (!raf) raf = requestAnimationFrame(sync); }
    function qg() { geo = true; q(); }
    tr.addEventListener('scroll', q, { passive: true });
    window.addEventListener('resize', qg);
    if (window.ResizeObserver) new ResizeObserver(qg).observe(tr);
    if (window.MutationObserver) new MutationObserver(qg).observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(qg);
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fh-sdir]'); if (!b) return;
      stop = true;
      tr.scrollBy({ left: +b.getAttribute('data-fh-sdir') * Math.max(140, tr.clientWidth * 0.7), behavior: reduce ? 'auto' : 'smooth' });
    });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { tr.addEventListener(ev, function () { stop = true; }, { passive: true }); });
    sync();

    /* the nudge: once per visit for each kind of row, never with reduced motion */
    var KEY = 'fh-nudge-' + kind;
    function done() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return true; } }
    function nudge() {
      if (reduce || stop || done()) return;
      var max = tr.scrollWidth - tr.clientWidth; if (max < 24 || tr.offsetParent === null) return;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      var from = tr.scrollLeft, dir = from < max - 8 ? 1 : -1, dist = dir * Math.min(72, dir > 0 ? max - from : from);
      var snap = tr.style.scrollSnapType, t0 = 0, D1 = 480, HOLD = 160, D2 = 620;
      tr.style.scrollSnapType = 'none';
      function out(x) { return 1 - Math.pow(1 - x, 3); }
      function io(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
      function end() { tr.style.scrollSnapType = snap; q(); }
      function step(now) {
        if (!t0) t0 = now;
        if (stop) { end(); return; }
        var t = now - t0, x;
        if (t < D1) x = out(t / D1);
        else if (t < D1 + HOLD) x = 1;
        else if (t < D1 + HOLD + D2) x = 1 - io((t - D1 - HOLD) / D2);
        else { tr.scrollLeft = from; end(); return; }
        tr.scrollLeft = from + dist * x;
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!reduce && 'IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || en.intersectionRatio < 0.9) return;
          seen.disconnect(); setTimeout(nudge, 700);
        });
      }, { threshold: [0.9], rootMargin: '0px 0px -18% 0px' }); /* well inside the screen, not peeking at the bottom */
      seen.observe(tr);
    }
  }
  function initChipRows(scope) { $$('[data-fh-scroller]', scope || document).forEach(chipScroller); }

  /* rails and rows that arrive after the page has loaded (recommendations, bundle cards, a section added in the
     theme editor) are wired a moment later; rows already wired are skipped, so this costs one quick look */
  if (window.MutationObserver) {
    var lateT;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (!ms[i].addedNodes.length) continue;
        clearTimeout(lateT); lateT = setTimeout(function () { initScrollers(document); initChipRows(document); }, 300); return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* --------------------------------------------------------- smooth jumps
     A button or link to a section glides there instead of jumping. On the same page it glides straight away; to a
     section on another page of the shop, that page opens at the top and then glides down to it. Links keep their
     real addresses (#designs, /#b2b), so search engines and shared links see no change, and nothing extra loads:
     the glide only runs on a click. It stops just under the sticky header, gives way at once to a swipe, wheel or
     key, puts the #section in the address bar and moves keyboard focus there. Reduced motion gets the same landing
     without the glide. Tabs, menus, drawers and pop-ups keep their own links. */
  (function () {
    var KEY = 'fh-glide', ID = /^#[A-Za-z][\w-]*$/, PATHS = /^\/($|pages\/|collections|products\/|blogs\/)/;
    var SKIP = '[role="tablist"], [role="tab"], [aria-controls], [data-toggle], [data-bs-toggle], .halo-sidebar, .halo-popup, #halo-cart-sidebar, [data-fh-noglide], dialog';
    function topBar() {
      var b = 0, vw = window.innerWidth, vh = window.innerHeight;
      $$('header, sticky-header, [class*="header"], .shopify-section').forEach(function (h) {
        if (h.closest('main, #MainContent')) return;
        var cs = getComputedStyle(h); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        if (cs.visibility === 'hidden' || cs.display === 'none') return;
        var r = h.getBoundingClientRect();
        if (r.top > 2 || r.height < 20 || r.height > vh * 0.4 || r.width < vw * 0.5) return;
        if (r.bottom > b) b = r.bottom;
      });
      return b;
    }
    function shown(t) { return t && !t.closest('[hidden], .halo-sidebar, .halo-popup, dialog') && (t.offsetParent !== null || getComputedStyle(t).position === 'fixed') && !t.closest(SKIP); }
    function landing(t) { var y = t.getBoundingClientRect().top + window.pageYOffset - topBar() - 12; return Math.max(0, Math.min(y, document.documentElement.scrollHeight - window.innerHeight)); }
    function focus(t) {
      if (!t.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(t.tagName)) {
        t.setAttribute('tabindex', '-1');
        t.addEventListener('blur', function () { t.removeAttribute('tabindex'); }, { once: true });
      }
      try { t.focus({ preventScroll: true }); } catch (e) {}
    }
    var run = 0;
    function glide(t, then) {
      var id = ++run, y0 = window.pageYOffset, dist = Math.abs(landing(t) - y0);
      var off = function () { run++; detach(); };
      var evs = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
      function detach() { evs.forEach(function (ev) { window.removeEventListener(ev, off, { passive: true }); }); }
      function land() { detach(); window.scrollTo(0, landing(t)); focus(t); if (then) then(); }
      if (reduce || dist < 4) { land(); return; }
      evs.forEach(function (ev) { window.addEventListener(ev, off, { passive: true }); });
      var D = Math.min(1100, Math.max(450, 260 + dist * 0.16)), t0 = 0;
      function ease(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
      function step(now) {
        if (id !== run) return;
        if (!t0) t0 = now;
        var x = Math.min(1, (now - t0) / D);
        window.scrollTo(0, y0 + (landing(t) - y0) * ease(x)); /* aims at where the section is now, in case images above it load */
        if (x < 1) requestAnimationFrame(step); else land();
      }
      requestAnimationFrame(step);
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href*="#"]'); if (!a || a.closest(SKIP)) return;
      if ((a.target && a.target !== '_self') || a.hasAttribute('download')) return;
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
      if (u.origin !== location.origin || !ID.test(u.hash)) return;
      var here = u.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '') && u.search === location.search;
      if (here) {
        var t = document.getElementById(u.hash.slice(1)); if (!shown(t)) return;
        e.preventDefault();
        glide(t, function () { if (location.hash !== u.hash) try { history.pushState(null, '', u.hash); } catch (x) {} });
        return;
      }
      if (!PATHS.test(u.pathname)) return;
      try { sessionStorage.setItem(KEY, JSON.stringify({ p: u.pathname, h: u.hash })); } catch (x) { return; }
      e.preventDefault();
      location.assign(u.pathname + u.search);
    });
    /* arriving from such a link: show the top of the page for a beat, then glide to the section */
    var g = null; try { g = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (x) {}
    if (g && g.h && g.p && g.p.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) {
      var go = function () {
        var t = document.getElementById(g.h.slice(1)); if (!t) return;
        /* the #section goes into the address bar only once the page has fully loaded and the glide has landed:
           the theme jumps to any #address it finds while loading, which would cut the glide short */
        var mark = function () { try { history.replaceState(history.state, '', g.h); } catch (x) {} };
        setTimeout(function () {
          glide(t, function () {
            if (document.readyState === 'complete') setTimeout(mark, 60); else window.addEventListener('load', function () { setTimeout(mark, 60); }, { once: true });
            /* if photos above the section finish loading after the glide and push it down, follow it once */
            var y = window.pageYOffset, moved = false, user = function () { moved = true; };
            ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, user, { passive: true, once: true }); });
            var fix = function () { if (!moved && window.pageYOffset === y && Math.abs(landing(t) - y) > 40) window.scrollTo(0, landing(t)); };
            if (document.readyState === 'complete') setTimeout(fix, 400); else window.addEventListener('load', fix, { once: true });
          });
        }, reduce ? 0 : 280);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go, { once: true }); else go();
    }
  })();
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fh-showmore]'); if (!b) return; e.preventDefault();
    var sec = b.closest('[data-fh-section]') || document;
    $$('.fh-rail', sec).forEach(function (r) { r.classList.add('fh-is-all'); });
    var wrap = b.closest('.fh-showmore-wrap'); if (wrap) wrap.hidden = true; else b.hidden = true;
    FH.refreshScrollers(sec);
  });

  /* --------------------------------------------------------- pricing engine
     Mirrors the store's automatic discounts: same-family quantity ladders (AED off
     each piece), mix & match pairs (buy 1 of A, AED off 1 of B) and static 3-piece
     sets (buy 2 from the buy families, AED off 1 from the get families). Like
     Shopify's non-combining automatic discounts, only the single best rule applies. */
  var FAMS = ['mug', 'tumbler', 'bottle', 'magsafe', 'coaster'];
  var FAM_ICON = {
    mug: '<path d="M5 8h11v7a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z"/><path d="M16 10h2a2.5 2.5 0 0 1 0 5h-2"/><path d="M8 4c0 1.5 1 1.5 1 3M12 4c0 1.5 1 1.5 1 3"/>',
    tumbler: '<path d="M6 5h12l-1.5 15h-9z"/><path d="M5 5h14M13 2l2 3"/>',
    bottle: '<path d="M10 3h4v3l2 3v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9l2-3z"/><path d="M8 13h8"/>',
    magsafe: '<path d="M6 4v8a6 6 0 0 0 12 0V4"/><path d="M6 4h4v8a2 2 0 0 0 4 0V4h4"/><path d="M6 8h4M14 8h4"/>',
    coaster: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>'
  };
  function famIcon(f) { return '<svg class="fh-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (FAM_ICON[f] || FAM_ICON.mug) + '</svg>'; }
  var rulesCache;
  function rules() {
    if (rulesCache !== undefined) return rulesCache;
    rulesCache = null;
    var el = $('script[data-fh-rules]');
    if (el) { try { var r = JSON.parse(el.textContent || '{}'); if (r && (r.ladders || r.pairs || r.sets)) rulesCache = { ref: r.ref || {}, ladders: r.ladders || [], pairs: r.pairs || [], sets: r.sets || [] }; } catch (_) {} }
    return rulesCache;
  }
  function cents(aed) { return Math.round((parseFloat(aed) || 0) * 100); }
  function sum(arr) { return arr.reduce(function (a, b) { return a + b; }, 0); }
  /* items: [{f: family, p: price in cents}] -> {list, save, total, rule, kind, pct} */
  function best(items) {
    var list = 0, byFam = {};
    items.forEach(function (it) { var p = it.p || 0; list += p; var f = it.f || 'other'; (byFam[f] = byFam[f] || []).push(p); });
    Object.keys(byFam).forEach(function (f) { byFam[f].sort(function (a, b) { return a - b; }); });
    var R = rules() || { ladders: [], pairs: [], sets: [] };
    var top = { save: 0, rule: null, kind: '' };
    var cnt = function (f) { return (byFam[f] || []).length; };
    var consider = function (save, rule, kind) { save = Math.max(0, Math.round(save)); if (save > top.save) top = { save: save, rule: rule, kind: kind }; };
    R.ladders.forEach(function (L) { var n = cnt(L.fam); if (n >= (L.min || 1)) consider(Math.min(cents(L.off) * n, sum(byFam[L.fam])), L, 'ladder'); });
    R.pairs.forEach(function (Pr) {
      var n = Math.min(cnt(Pr.buy), cnt(Pr.get)); if (!n) return;
      consider(sum(byFam[Pr.get].slice(0, n).map(function (p) { return Math.min(p, cents(Pr.off)); })), Pr, 'pair');
    });
    R.sets.forEach(function (S) {
      var buys = 0; (S.buy || []).forEach(function (f) { buys += cnt(f); });
      var gets = []; (S.get || []).forEach(function (f) { gets = gets.concat(byFam[f] || []); });
      gets.sort(function (a, b) { return a - b; });
      var n = Math.min(Math.floor(buys / (S.qty || 2)), gets.length); if (!n) return;
      consider(sum(gets.slice(0, n).map(function (p) { return Math.min(p, cents(S.off)); })), S, 'set');
    });
    return { list: list, save: top.save, total: list - top.save, rule: top.rule, kind: top.kind, pct: list ? Math.round(top.save / list * 100) : 0 };
  }
  function famNames(section) {
    var d = { mug: 'Mugs', tumbler: 'Tumblers', bottle: 'Bottles', magsafe: 'MagSafe bottles', coaster: 'Coasters', pair: 'Mix & match pair', set: 'Mix & match set', each: 'each' };
    var host = (section && section.closest && section.closest('[data-fh-fams]')) || $('[data-fh-fams]', section) || $('[data-fh-fams]');
    if (host) { try { var j = JSON.parse(host.getAttribute('data-fh-fams') || '{}'); Object.keys(j).forEach(function (k) { if (j[k]) d[k] = j[k]; }); } catch (_) {} }
    return d;
  }
  function ruleLabel(res, fams) {
    if (!res || !res.rule) return '';
    fams = fams || famNames();
    if (res.kind === 'ladder') return (fams[res.rule.fam] || res.rule.fam) + ' ' + res.rule.min + '+ · AED ' + res.rule.off + ' ' + (fams.off || 'off') + ' ' + fams.each;
    if (res.kind === 'pair') return fams.pair + ' · ' + res.pct + '%';
    return (res.rule.name || fams.set) + ' · ' + res.pct + '%';
  }
  FH.pricing = { best: best, rules: rules, label: ruleLabel, cents: cents, families: famNames };

  /* pricing panel: one card per family from rules.ref + ladders */
  function renderLadders(section) {
    var panel = $('[data-fh-ladders]', section); if (!panel) return;
    var grid = $('[data-fh-ladder-grid]', panel), R = rules();
    if (!grid || !R) { panel.hidden = true; return; }
    var fams = famNames(section), single = panel.getAttribute('data-single') || 'pc', pcs = panel.getAttribute('data-pcs') || 'pcs';
    var html = '';
    FAMS.forEach(function (f) {
      var ref = R.ref && parseFloat(R.ref[f]); if (!ref) return;
      var steps = R.ladders.filter(function (L) { return L.fam === f; }).sort(function (a, b) { return a.min - b.min; });
      if (!steps.length) return;
      var num = function (aed) { return money(cents(aed)).replace(/[^\d.,]/g, ''); };
      var rows = '<div class="fh-pl-step"><em>1 ' + esc(single) + '</em><strong>' + num(ref) + '</strong></div>';
      steps.forEach(function (L, i) { rows += '<div class="fh-pl-step' + (i === steps.length - 1 ? ' fh-best' : '') + '"><em>' + L.min + '+ ' + esc(pcs) + '</em><strong>' + num(ref - L.off) + '</strong></div>'; });
      html += '<div class="fh-pl-fam"><b>' + famIcon(f) + esc(fams[f] || f) + '</b><div class="fh-pl-steps">' + rows + '</div></div>';
    });
    grid.innerHTML = html;
    if (!html) panel.hidden = true;
  }

  /* ready-made sets built from real products: live total, saving sticker, deal line */
  function initSets(section) {
    var fams = famNames(section);
    $$('[data-fh-set]', section).forEach(function (card) {
      var items; try { items = JSON.parse(card.getAttribute('data-fh-set') || '[]'); } catch (_) { return; }
      if (!items || !items.length) return;
      var res = best(items);
      var total = $('[data-fh-set-total]', card), list = $('[data-fh-set-list]', card), save = $('[data-fh-set-save]', card), saveTxt = $('[data-fh-set-savetext]', card), deal = $('[data-fh-set-deal]', card);
      if (total) total.textContent = money(res.total);
      if (list) { list.textContent = money(res.list); list.hidden = !res.save; }
      if (save) { save.hidden = !res.save; if (saveTxt) saveTxt.textContent = (save.getAttribute('data-save') || 'Save') + ' ' + money(res.save) + (res.pct ? ' · ' + res.pct + '%' : ''); }
      if (deal) { deal.hidden = !res.save; deal.textContent = res.save ? ((deal.getAttribute('data-prefix') || 'Best deal:') + ' ' + ruleLabel(res, fams)) : ''; }
    });
  }

  /* ---------------------------------------------------------- countries data */
  var REGION_LABEL = { 'Asia': 'Middle East & Asia', 'Africa': 'Africa', 'Europe': 'Europe', 'North America': 'Americas', 'South America': 'Americas', 'Oceania': 'Oceania' };
  var TYPE = { mug: { label: 'Mug · 320ml', kind: 'mug', crop: 'fh-crop-mug', h: 26 }, tumbler: { label: '480ml Tumbler', kind: 'tumbler', crop: 'fh-crop-tum', h: 46 } };
  var PH_MUG = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 260"><path d="M150 96 C 196 92, 206 160, 176 184 C 168 191, 160 195, 150 196" fill="none" stroke="#c9ccd8" stroke-width="18" stroke-linecap="round"/><path d="M40 74 H156 V222 Q156 238 140 238 H56 Q40 238 40 222 Z" fill="#d9dbe6"/><ellipse cx="98" cy="74" rx="58" ry="12" fill="#fff"/></svg>');
  var PH_TUM = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 260"><rect x="14" y="30" width="92" height="20" rx="8" fill="#1d1f2b"/><path d="M18 50 H102 L94 246 Q92 256 82 256 H38 Q28 256 26 246 Z" fill="#d9dbe6"/></svg>');

  function parseCountries(section) {
    var scripts = $$('script[data-fh-countries]', section);
    if (!scripts.length) scripts = $$('script[data-fh-countries]');
    var base = '', products = [];
    scripts.forEach(function (s) {
      try { var d = JSON.parse(s.textContent || '{}'); base = d.base || base; (d.products || []).forEach(function (p) { products.push(p); }); } catch (_) {}
    });
    var map = {}, list = [];
    products.forEach(function (p) {
      if (!p.n) return;
      var c = map[p.n];
      if (!c) { c = map[p.n] = { name: p.n, region: p.r || '', mug: null, mugs: [], tumbler: null }; list.push(c); }
      if (p.r && !c.region) c.region = p.r;
      var item = { id: p.id, price: p.p, url: p.u, img: p.i ? (p.k === 1 ? p.i : base + p.i) : '', cutout: p.k === 1, colour: p.c || '', title: p.title || '' };
      if (p.t === 'tumbler') { if (!c.tumbler) c.tumbler = item; }
      else { c.mugs.push(item); if (!c.mug) c.mug = item; }
    });
    list.sort(function (a, b) { return a.name.localeCompare(b.name); });
    return { list: list, map: map, base: base };
  }
  function regionOf(c) { return REGION_LABEL[c.region] || c.region || ''; }
  function photoHTML(item, type, cls) {
    var T = TYPE[type];
    if (!item || !item.img) return '<span class="fh-photo fh-cutout ' + (cls || '') + '"><img src="' + (type === 'tumbler' ? PH_TUM : PH_MUG) + '" alt=""></span>';
    return '<span class="fh-photo ' + (item.cutout ? 'fh-cutout' : T.crop) + ' ' + (cls || '') + '"><img src="' + esc(item.img) + '" alt="" loading="lazy" decoding="async"></span>';
  }
  function imgW(url, w) { return url && !/^data:/.test(url) ? url.replace(/(\?|&)width=\d+/, '') + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : url; }

  /* ------------------------------------------------------- countries finder */
  function initFinder(section) {
    var finder = $('[data-fh-finder]', section);
    if (!finder) return;
    var data = parseCountries(section);
    var list = $('[data-fh-clist]', finder), q = $('[data-fh-cq]', finder), prev = $('[data-fh-preview]', finder), empty = $('[data-fh-empty]', finder);
    var count = $('[data-fh-count]', section);
    var pimg = $('[data-fh-pimg]', prev), pname = $('[data-fh-pname]', prev), pregion = $('[data-fh-pregion]', prev), pprice = $('[data-fh-pprice]', prev), padd = $('[data-fh-padd]', prev), ppair = $('[data-fh-ppair]', prev), pview = $('[data-fh-pview]', prev);
    var regionF = 'all', query = '', selected = null, ptype = ($('[data-ptype][aria-pressed="true"]', finder) || {}).getAttribute ? ($('[data-ptype][aria-pressed="true"]', finder).getAttribute('data-ptype')) : 'mug';
    if (!data.list.length) { if (empty) empty.hidden = false; if (prev) prev.hidden = true; if (list) list.hidden = true; return; }
    var preferred = finder.getAttribute('data-default') || '';
    selected = (data.map[preferred] ? preferred : data.list[0].name);
    function filtered() {
      return data.list.filter(function (c) {
        var okR = regionF === 'all' || (regionF === 'Americas' ? /America/.test(c.region) : c.region === regionF);
        return okR && c.name.toLowerCase().indexOf(query) > -1;
      });
    }
    function render() {
      var rows = filtered();
      list.innerHTML = rows.map(function (c) { return '<button type="button" class="fh-cchip' + ((c.mug || c.tumbler) ? ' fh-has' : '') + '" role="option" aria-pressed="' + (c.name === selected) + '" data-c="' + esc(c.name) + '">' + esc(c.name) + '</button>'; }).join('');
      if (count) count.textContent = (regionF === 'all' && !query) ? data.list.length : rows.length;
    }
    function select(n) {
      var c = data.map[n]; if (!c) return; selected = n;
      var item = ptype === 'tumbler' ? c.tumbler : c.mug;
      var T = TYPE[ptype];
      prev.classList.remove('fh-is-swap'); void prev.offsetWidth; prev.classList.add('fh-is-swap');
      pimg.innerHTML = photoHTML(item ? { img: imgW(item.img, 480), cutout: item.cutout } : null, ptype);
      pname.textContent = n + ' ' + T.label;
      pregion.textContent = regionOf(c) + (item ? (item.colour ? ' · ' + item.colour + (ptype === 'tumbler' ? ' lid' : ' handle') : '') : ' · coming soon');
      pprice.textContent = item ? money(item.price) : '';
      if (padd) { padd.disabled = !item; padd.setAttribute('data-fh-add', item ? item.id : ''); padd.setAttribute('data-fh-label', n + ' ' + T.label); }
      if (ppair) { var both = c.mug && c.tumbler; ppair.hidden = !both; if (both) { ppair.setAttribute('data-fh-add', c.mug.id + ',' + c.tumbler.id); ppair.setAttribute('data-fh-label', n + ' mug + tumbler'); var pairTxt = $('[data-fh-pairprice]', ppair); if (pairTxt) pairTxt.textContent = money(best([{ f: 'mug', p: c.mug.price }, { f: 'tumbler', p: c.tumbler.price }]).total); } }
      if (pview) { pview.href = item ? item.url : '#'; pview.hidden = !item; }
      $$('.fh-cchip', list).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === n ? 'true' : 'false'); });
    }
    list.addEventListener('click', function (e) { var b = e.target.closest('.fh-cchip'); if (b) select(b.getAttribute('data-c')); });
    if (q) q.addEventListener('input', function () { query = q.value.trim().toLowerCase(); render(); var first = $('.fh-cchip', list); if (query && first) select(first.getAttribute('data-c')); });
    $$('[data-ptype]', finder).forEach(function (b) { b.addEventListener('click', function () { $$('[data-ptype]', finder).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); ptype = b.getAttribute('data-ptype'); select(selected); }); });
    $$('.fh-rchip', finder).forEach(function (b) { b.addEventListener('click', function () { $$('.fh-rchip', finder).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); var r = b.getAttribute('data-region'); regionF = (r === 'North America' || r === 'South America') ? 'Americas' : r; render(); }); });
    render(); select(selected);
    // marquee
    var track = $('[data-fh-mugtrack]', section);
    if (track) {
      var featured = (track.getAttribute('data-featured') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var pool = featured.length ? featured.map(function (n) { return data.map[n]; }).filter(Boolean) : data.list.filter(function (c) { return c.mug || c.tumbler; }).slice(0, 12);
      var html = pool.map(function (c, i) {
        var useT = (i % 2 && c.tumbler) || !c.mug; var item = useT ? c.tumbler : c.mug; var t = useT ? 'tumbler' : 'mug';
        return '<div class="fh-m">' + photoHTML(item ? { img: imgW(item.img, 300), cutout: item.cutout } : null, t, useT ? 'fh-tall' : '') + '<span>' + esc(c.name) + '</span></div>';
      }).join('');
      track.innerHTML = reduce ? html : html + html;
      track.parentElement.hidden = !pool.length;
    }
  }

  /* --------------------------------------------------------- bundle builder */
  function initBundles(section) {
    var el = $('[data-fh-builder]', section);
    if (!el) return;
    var data = parseCountries(section);
    var fams = famNames(section);
    var chips = $('[data-fh-bchips]', el), shelf = $('[data-fh-bshelf]', el), q = $('[data-fh-bq]', el), empty = $('[data-fh-bempty]', section);
    var out = { items: $('[data-fh-bitems]', el), list: $('[data-fh-blist]', el), tier: $('[data-fh-btier]', el), save: $('[data-fh-bsave]', el), total: $('[data-fh-btotal]', el), bar: $('[data-fh-bbar]', el), next: $('[data-fh-bnext]', el), add: $('[data-fh-badd]', el), count: $('[data-fh-bcount]', el), hint: $('[data-fh-bhint]', el) };
    var FMT = {};
    $$('.fh-fmt', el).forEach(function (b) { FMT[b.getAttribute('data-fmt')] = { max: parseInt(b.getAttribute('data-max'), 10) || 24, per: b.getAttribute('data-per') === 'custom' ? null : b.getAttribute('data-per').split('+'), hint: b.getAttribute('data-hint') || '' }; });
    var fmt = ($('.fh-fmt[aria-pressed="true"]', el) || $('.fh-fmt', el)).getAttribute('data-fmt'), btype = 'mug', picks = [], query = '';
    if (!data.list.length) { if (empty) empty.hidden = false; el.hidden = true; $$('[data-fh-ideas]', section).forEach(function (x) { x.hidden = true; }); return; }
    var priceOf = function (t) { var c = data.list.filter(function (x) { return x[t]; })[0]; return c ? c[t].price : 0; };
    var PRICE = { mug: priceOf('mug'), tumbler: priceOf('tumbler') };
    function priced(it) { return it.map(function (x) { var item = itemFor(x); return { f: x.t, p: item ? item.price : PRICE[x.t] }; }); }
    function nudge(it, res, F) {
      var base = priced(it), words = { mug: out.next.getAttribute('data-mug') || 'a mug', tumbler: out.next.getAttribute('data-tumbler') || 'a tumbler', country: out.next.getAttribute('data-country') || 'another country' }, cands = [];
      if (F.per) cands.push({ label: words.country, add: F.per.map(function (f) { return { f: f, p: PRICE[f] }; }) });
      else { cands.push({ label: words.mug, add: [{ f: 'mug', p: PRICE.mug }] }); cands.push({ label: words.tumbler, add: [{ f: 'tumbler', p: PRICE.tumbler }] }); }
      var top = null;
      cands.forEach(function (c) { if (c.add.some(function (a) { return !a.p; })) return; var gain = best(base.concat(c.add)).save - res.save; if (gain > 0 && (!top || gain > top.gain)) top = { label: c.label, gain: gain }; });
      return top;
    }
    function items() { var F = FMT[fmt]; if (F.per) { var r = []; picks.forEach(function (p) { F.per.forEach(function (t) { r.push({ c: p.c, t: t }); }); }); return r; } return picks; }
    function itemFor(x) { var c = data.map[x.c]; return c ? (c[x.t || 'mug'] || null) : null; }
    function renderChips() {
      var rows = data.list.filter(function (c) { return c.name.toLowerCase().indexOf(query) > -1; });
      chips.innerHTML = rows.map(function (c) { var n = picks.filter(function (p) { return p.c === c.name; }).length; return '<button type="button" class="fh-bchip' + ((c.mug || c.tumbler) ? ' fh-has' : '') + '" role="option" aria-selected="' + (n > 0) + '" data-c="' + esc(c.name) + '">' + esc(c.name) + (n > 1 ? '<span class="fh-n">×' + n + '</span>' : '') + '</button>'; }).join('');
      var F = FMT[fmt];
      if (out.count) out.count.textContent = (F.per ? picks.length : items().length) + ' of ' + (F.per ? F.max : '∞');
      if (out.hint) out.hint.textContent = F.hint;
    }
    function renderShelf() {
      var it = items(), n = it.length;
      shelf.innerHTML = '<div class="fh-floor"></div>' + (n ? '' : '<div class="fh-empty">' + esc(shelf.getAttribute('data-empty') || 'Tap countries to fill the shelf.') + '</div>');
      it.forEach(function (x, i) {
        var item = itemFor(x); var T = TYPE[x.t] || TYPE.mug; var left = n === 1 ? 50 : (8 + (84 * (i + .5) / n));
        var d = document.createElement('div'); d.className = 'fh-bi'; d.style.cssText = 'left:' + left + '%;height:' + T.h + '%;z-index:' + (i + 1) + ';animation-delay:' + (i * 60) + 'ms';
        d.innerHTML = photoHTML(item ? { img: imgW(item.img, 360), cutout: item.cutout } : null, x.t) + '<span class="fh-lbl">' + esc(x.c) + '</span>';
        shelf.appendChild(d);
      });
    }
    function renderPrice() {
      var it = items(), n = it.length, missing = 0;
      it.forEach(function (x) { if (!itemFor(x)) missing++; });
      var res = best(priced(it)), list = res.list, total = res.total;
      if (out.items) out.items.textContent = n;
      if (out.list) out.list.textContent = money(list);
      if (out.tier) out.tier.textContent = res.save ? ruleLabel(res, fams) : (out.tier.getAttribute('data-none') || out.tier.textContent);
      if (out.save) out.save.textContent = res.save ? '− ' + money(res.save) : '';
      if (out.total) out.total.textContent = money(total);
      var F = FMT[fmt], full = F.per && picks.length >= F.max, nx = (n && !full && out.next) ? nudge(it, res, F) : null;
      if (out.bar) out.bar.style.width = Math.min(100, Math.round(res.pct / 15 * 100)) + '%';
      if (out.next) out.next.textContent = nx ? (out.next.getAttribute('data-add') || 'Add [item] to save [amount] more').replace('[item]', nx.label).replace('[amount]', money(nx.gain)) : (res.save ? (out.next.getAttribute('data-top') || 'Best saving unlocked') : '');
      if (out.add) {
        var ids = it.map(function (x) { var item = itemFor(x); return item ? item.id : null; }).filter(Boolean);
        out.add.disabled = !n || missing > 0;
        out.add.textContent = !n ? (out.add.getAttribute('data-empty') || 'Pick a country to start') : missing ? (out.add.getAttribute('data-missing') || 'Some pieces are not available yet') : ('Add ' + n + ' piece' + (n > 1 ? 's' : '') + ' to bag · ' + money(total));
        out.add.setAttribute('data-fh-add', ids.join(',')); out.add.setAttribute('data-fh-label', n + '-piece Countries bundle');
      }
    }
    function render() { el.setAttribute('data-fmt', fmt); renderChips(); renderShelf(); renderPrice(); }
    function setFmt(f, keep) {
      var prev = items();
      fmt = f; $$('.fh-fmt', el).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fmt') === f ? 'true' : 'false'); });
      var F = FMT[f];
      if (!keep) { if (F.per) { var seen = {}; picks = picks.filter(function (p) { if (seen[p.c]) return false; seen[p.c] = 1; return true; }).slice(0, F.max).map(function (p) { return { c: p.c }; }); } else { picks = prev.map(function (x) { return { c: x.c, t: x.t || 'mug' }; }); } }
      render();
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.fh-bchip'); if (!b) return; var c = b.getAttribute('data-c'); var F = FMT[fmt];
      if (F.per) { var i = picks.map(function (p) { return p.c; }).indexOf(c); if (i > -1) picks.splice(i, 1); else { if (picks.length >= F.max) picks.shift(); picks.push({ c: c }); } }
      else { var j = -1; picks.forEach(function (p, k) { if (p.c === c && p.t === btype) j = k; }); if (j > -1) picks.splice(j, 1); else picks.push({ c: c, t: btype }); }
      render();
    });
    $$('.fh-fmt', el).forEach(function (b) { b.addEventListener('click', function () { setFmt(b.getAttribute('data-fmt')); }); });
    $$('[data-btype]', el).forEach(function (b) { b.addEventListener('click', function () { $$('[data-btype]', el).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); btype = b.getAttribute('data-btype'); renderChips(); }); });
    if (q) q.addEventListener('input', function () { query = q.value.trim().toLowerCase(); renderChips(); });
    // curated idea cards
    $$('[data-fh-idea]', section).forEach(function (card) {
      var d; try { d = JSON.parse(card.getAttribute('data-fh-idea')); } catch (_) { return; }
      var its = d.items || [];
      var res = best(priced(its)), list = res.list, total = res.total, t = res.save;
      var art = $('.fh-bart', card);
      if (art) its.slice(0, 6).forEach(function (x) { var item = itemFor(x); var span = document.createElement('span'); span.className = 'fh-ba' + (x.t === 'tumbler' ? ' fh-t' : ''); span.innerHTML = photoHTML(item ? { img: imgW(item.img, 240), cutout: item.cutout } : null, x.t); art.appendChild(span); });
      var price = $('[data-fh-iprice]', card); if (price) price.innerHTML = money(total) + (t ? ' <s>' + money(list) + '</s>' : '');
      card.addEventListener('click', function () {
        var customKey = Object.keys(FMT).filter(function (k) { return !FMT[k].per; })[0];
        if (d.fmt && FMT[d.fmt] && FMT[d.fmt].per) { picks = its.filter(function (x, i, a) { return a.map(function (y) { return y.c; }).indexOf(x.c) === i; }).map(function (x) { return { c: x.c }; }); setFmt(d.fmt, true); }
        else if (customKey) { picks = its.map(function (x) { return { c: x.c, t: x.t }; }); setFmt(customKey, true); }
        else { picks = its.filter(function (x, i, a) { return a.map(function (y) { return y.c; }).indexOf(x.c) === i; }).map(function (x) { return { c: x.c }; }); setFmt(Object.keys(FMT)[0], false); }
        toast('Loaded “' + (d.name || 'bundle') + '”. Swap any country');
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    var def = el.getAttribute('data-default') || '';
    picks = def && data.map[def] ? [{ c: def }] : (data.list[0] ? [{ c: data.list[0].name }] : []);
    render();
  }

  /* --------------------------------------------------------------- launches */
  var modal, lastFocus;
  function openModal(section, name, meta, color, forCard) {
    modal = $('[data-fh-notify]', section) || $('[data-fh-notify]');
    if (!modal) return;
    lastFocus = document.activeElement; modal.classList.remove('fh-is-done');
    var nm = $('[data-fh-ntname]', modal), mt = $('[data-fh-ntmeta]', modal), prod = $('[data-fh-ntprod] svg', modal), prodImg = $('[data-fh-ntimg]', modal);
    if (nm) nm.textContent = name || modal.getAttribute('data-default-name') || 'Fann Bliss launches';
    if (mt) mt.textContent = meta || modal.getAttribute('data-default-meta') || '';
    if (prod && color) prod.style.setProperty('--c', color);
    if (prodImg) { var src = forCard && forCard.getAttribute('data-image'); if (src) { prodImg.src = src; prodImg.hidden = false; if (prod) prod.hidden = true; } else { prodImg.hidden = true; if (prod) prod.hidden = false; } }
    var hp = $('input[name="contact[product]"]', modal); if (hp) hp.value = name || '';
    modal.setAttribute('data-for', forCard ? forCard.getAttribute('data-name') : '');
    modal.classList.add('fh-on'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    setTimeout(function () { var em = $('input[type="email"]', modal); if (em) em.focus(); }, 350);
  }
  function closeModal() { if (!modal || !modal.classList.contains('fh-on')) return; modal.classList.remove('fh-on'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  function initLaunches(section) {
    $$('.fh-lcard', section).forEach(function (card) {
      var svg = $('svg.fh-prod', card), nm = $('[data-cname]', card);
      $$('[data-swatches] .fh-swatch', card).forEach(function (s) { s.addEventListener('click', function () { $$('[data-swatches] .fh-swatch', card).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); s.setAttribute('aria-pressed', 'true'); if (svg) svg.style.setProperty('--c', s.getAttribute('data-c')); if (nm) nm.textContent = s.getAttribute('data-n'); if (svg && !reduce) svg.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.04) rotate(-1deg)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'cubic-bezier(.34,1.4,.4,1)' }); }); });
      $$('[data-sizes] .fh-size', card).forEach(function (s) { s.addEventListener('click', function () { $$('[data-sizes] .fh-size', card).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); s.setAttribute('aria-pressed', 'true'); }); });
    });
    section.addEventListener('click', function (e) {
      var b = e.target.closest('[data-notify]'); if (!b) return; e.preventDefault();
      var card = b.closest('.fh-lcard'); var meta = '', color = '';
      var m = $('[data-fh-notify]', section) || $('[data-fh-notify]');
      if (card) {
        var sw = $('[data-swatches] [aria-pressed="true"]', card), sz = $('[data-sizes] [aria-pressed="true"]', card), eta = $('.fh-eta', card);
        meta = [sw && sw.getAttribute('data-n'), sz && sz.textContent.trim(), eta && eta.textContent.trim().toLowerCase()].filter(Boolean).join(' · '); color = sw && sw.getAttribute('data-c');
        if (m) { var colSel = $('select[name="contact[colour]"]', m), sizeSel = $('select[name="contact[size]"]', m);
          function fill(sel, btns, attr) { if (!sel) return; var vals = btns.map(function (x) { return attr ? x.getAttribute(attr) : x.textContent.trim(); }); sel.innerHTML = vals.map(function (v) { return '<option>' + esc(v) + '</option>'; }).join('') + '<option>' + esc(sel.getAttribute('data-any') || 'Not sure yet') + '</option>'; if (btns.length) { var on = btns.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0]; if (on) sel.value = attr ? on.getAttribute(attr) : on.textContent.trim(); } }
          fill(colSel, $$('[data-swatches] .fh-swatch', card), 'data-n'); fill(sizeSel, $$('[data-sizes] .fh-size', card), null); }
      }
      openModal(section, b.getAttribute('data-notify'), meta, color, card);
    });
    var m = $('[data-fh-notify]', section);
    if (!m || m.__fh) return; m.__fh = true;
    $$('[data-close-modal]', m).forEach(function (b) { b.addEventListener('click', function (e) { if (b.tagName !== 'A') e.preventDefault(); closeModal(); }); });
    $$('.fh-size[data-interest]', m).forEach(function (s) { s.addEventListener('click', function () { s.setAttribute('aria-pressed', s.getAttribute('aria-pressed') !== 'true'); }); });
    var form = $('form', m);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var interests = $$('.fh-size[data-interest][aria-pressed="true"]', m).map(function (s) { return s.getAttribute('data-interest'); });
      var hi = $('input[name="contact[interests]"]', form); if (hi) hi.value = interests.join(', ');
      var wa = $('input[name="contact[whatsapp]"]', form);
      var tags = ['waitlist', 'waitlist:' + (m.getAttribute('data-for') || 'all').toLowerCase().replace(/[^a-z0-9]+/g, '-')];
      var colSel = $('select[name="contact[colour]"]', form), sizeSel = $('select[name="contact[size]"]', form);
      if (colSel && colSel.value) tags.push('colour:' + colSel.value.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
      if (sizeSel && sizeSel.value) tags.push('size:' + sizeSel.value.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
      interests.forEach(function (i) { tags.push('interest:' + i.toLowerCase().replace(/[^a-z0-9]+/g, '-')); });
      if (wa && wa.checked) tags.push('whatsapp-opt-in');
      var tagIn = $('input[name="contact[tags]"]', form); if (tagIn) tagIn.value = tags.join(',');
      var btn = $('button[type="submit"]', form); if (btn) btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: fd, headers: { 'Accept': 'text/html' }, redirect: 'follow' }).then(function (res) {
        if (!res.ok && res.status !== 302) throw new Error('bad');
        m.classList.add('fh-is-done');
        var card = $$('.fh-lcard', section).filter(function (c) { return c.getAttribute('data-name') === m.getAttribute('data-for'); })[0];
        if (card) { var n = $('[data-count]', card); if (n) n.textContent = (parseInt(n.textContent.replace(/\D/g, ''), 10) || 0) + 1; }
        if (btn) btn.removeAttribute('aria-busy');
      }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  /* ------------------------------------------------------------ personalize */
  function initPersonalize(section) {
    var inp = $('[data-fh-pname]', section), t = $('[data-fh-mugname]', section), svg = $('[data-fh-mugsvg]', section), cont = $('[data-fh-continue]', section), img = $('[data-fh-mugimg]', section), studio = $('[data-fh-studio]', section);
    if (!inp || !t) return;
    var base = cont ? (cont.getAttribute('data-base') || cont.getAttribute('href') || '') : '';
    var patch = ((studio && studio.getAttribute('data-patch')) || '15,27,41,57').split(',').map(parseFloat);
    var state = { font: 'script', variant: (studio && studio.getAttribute('data-variant')) || '', colour: '', ink: '' };
    var photo = !!img;
    function link() {
      if (!cont || !base) return;
      var v = (inp.value || '').trim(), q = [];
      if (state.variant) q.push('variant=' + state.variant);
      if (v) q.push('name=' + encodeURIComponent(v));
      q.push('font=' + state.font);
      if (state.ink) q.push('colour=' + encodeURIComponent(state.ink));
      cont.href = base + (base.indexOf('?') > -1 ? '&' : '?') + q.join('&');
    }
    function setSize(px) { t.setAttribute('font-size', px); t.style.fontSize = px + 'px'; }
    function fit() {
      var v = (inp.value || inp.getAttribute('placeholder') || 'Your name').trim(); t.textContent = v;
      var len = Math.max(v.length, 4), size;
      if (photo) {
        var w = patch[2], h = patch[3], bold = state.font === 'bold';
        size = Math.min(h * (bold ? .48 : .6), w * (bold ? 1.35 : 1.7) / len);
        setSize(size); t.setAttribute('x', patch[0] + w / 2);
        try { var bb = t.getBBox(); if (bb.width > w * .9) { size = size * (w * .9) / bb.width; setSize(size); } } catch (_) {}
        t.setAttribute('y', patch[1] + h / 2 + size * .34);
      } else { size = Math.max(16, Math.min(34, 300 / Math.max(v.length, 6))); setSize(size); }
      link();
    }
    inp.addEventListener('input', function () { fit(); if (!reduce) { t.classList.remove('fh-pop'); try { void t.getBBox(); } catch (_) {} t.classList.add('fh-pop'); } });
    $$('.fh-fonts button', section).forEach(function (b) { b.addEventListener('click', function () { $$('.fh-fonts button', section).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); var bold = b.getAttribute('data-font') === 'bold'; state.font = bold ? 'bold' : 'script'; t.style.fontFamily = bold ? 'var(--fh-font-display)' : 'var(--fh-font-accent)'; t.style.fontWeight = bold ? '800' : '700'; t.style.textTransform = bold ? 'uppercase' : 'none'; t.style.letterSpacing = bold ? '.06em' : '0'; fit(); }); });
    $$('[data-fh-mugswatches] .fh-swatch', section).forEach(function (sw) { sw.addEventListener('click', function () {
      $$('[data-fh-mugswatches] .fh-swatch', section).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); sw.setAttribute('aria-pressed', 'true');
      state.variant = sw.getAttribute('data-variant') || state.variant; state.colour = sw.getAttribute('data-n') || '';
      var src = sw.getAttribute('data-img');
      if (img && src) { img.classList.add('fh-swap'); var pre = new Image(); pre.onload = function () { img.srcset = src.replace(/width=800/, 'width=400') + ' 400w, ' + src + ' 800w'; img.src = src; img.classList.remove('fh-swap'); }; pre.onerror = function () { img.classList.remove('fh-swap'); }; pre.src = src; }
      else if (svg) svg.style.setProperty('--c', sw.getAttribute('data-c'));
      link();
    }); });
    $$('[data-fh-inkswatches] .fh-swatch', section).forEach(function (sw) { sw.addEventListener('click', function () {
      $$('[data-fh-inkswatches] .fh-swatch', section).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); sw.setAttribute('aria-pressed', 'true');
      state.ink = sw.getAttribute('data-n') || ''; t.style.fill = sw.getAttribute('data-c'); if (!photo && svg) svg.style.setProperty('--c', sw.getAttribute('data-c')); link();
    }); });
    fit();
    if (photo && document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(); });
  }

  /* --------------------------------------------------------------- everyday */
  function initEveryday(section) {
    var s = $('[data-fh-eco]', section), w = $('[data-fh-ecoweek]', section), y = $('[data-fh-ecoyear]', section);
    if (!s) return; var u = function () { if (w) w.textContent = s.value; if (y) y.textContent = (s.value * 52).toLocaleString('en'); }; s.addEventListener('input', u); u();
  }

  /* ------------------------------------------------------------------ forms */
  function initForms(section) {
    $$('[data-fh-chipgroup]', section).forEach(function (group) {
      var target = $('input[name="' + group.getAttribute('data-fh-chipgroup') + '"]', section);
      $$('button[aria-pressed]', group).forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true'); if (target) target.value = $$('button[aria-pressed="true"]', group).map(function (x) { return x.textContent.trim(); }).join(', '); }); });
      if (target) target.value = $$('button[aria-pressed="true"]', group).map(function (x) { return x.textContent.trim(); }).join(', ');
    });
    $$('form.fh-newsform', section).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('button[type="submit"]', form); if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), redirect: 'follow' }).then(function (res) {
          if (!res.ok) throw new Error('bad');
          var sec = form.closest('[data-fh-section]'); toast((sec && sec.getAttribute('data-success')) || 'Welcome! Check your inbox for your code'); var em = $('input[type="email"]', form); if (em) em.value = ''; if (btn) btn.removeAttribute('aria-busy');
        }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
      });
    });
    $$('form.fh-quote', section).forEach(function (form) { form.addEventListener('submit', function () { var btn = $('button[type="submit"]', form); if (btn) btn.setAttribute('aria-busy', 'true'); }); });
    if (/contact_posted=true/.test(location.search)) { var target = $('[data-fh-posted]', section); if (target) setTimeout(function () { target.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 200); }
  }

  /* ------------------------------------------------------------ faq/footer */
  function initFaq(section) { var ds = $$('[data-fh-faq] details', section); ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); }); }
  function initFooter(section) {
    var ds = $$('.fh-ftr .fh-col details', section); if (!ds.length) return;
    var sync = function () { var wide = window.innerWidth > 640; ds.forEach(function (d, i) { d.open = wide ? true : (i === 0 && d.open); }); };
    var w = window.innerWidth; sync(); window.addEventListener('resize', function () { if ((w > 640) !== (window.innerWidth > 640)) { w = window.innerWidth; sync(); } });
  }

  /* ------------------------------------------------------------------- init */
  function init(scope) {
    scope = scope || document;
    initReveal(scope); initHero(scope); initTabs(scope); initScrollers(scope); initChipRows(scope);
    $$('[data-fh-section]', scope).forEach(function (s) {
      if (s.__fhInit) return; s.__fhInit = true;
      var kind = s.getAttribute('data-fh-section');
      if (kind === 'campaigns') initFinder(s);
      if (kind === 'bundles') { renderLadders(s); initSets(s); initBundles(s); }
      if (kind === 'launches') initLaunches(s);
      if (kind === 'personalize') initPersonalize(s);
      if (kind === 'everyday') initEveryday(s);
      if (kind === 'b2b' || kind === 'newsletter') initForms(s);
      if (kind === 'faq') initFaq(s);
      if (kind === 'footer') initFooter(s);
    });
  }
  FH.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target; rulesCache = undefined; if (s) { $$('[data-fh-section]', s).forEach(function (x) { x.__fhInit = false; }); init(s); } });
})();
